import { render, staticRenderFns } from "./m-personal-agreement.vue?vue&type=template&id=79529dc2&scoped=true"
import script from "./m-personal-agreement.vue?vue&type=script&lang=js"
export * from "./m-personal-agreement.vue?vue&type=script&lang=js"
import style0 from "./m-personal-agreement.vue?vue&type=style&index=0&id=79529dc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79529dc2",
  null
  
)

export default component.exports